<span>{{serviceStatuses[data[fieldName]]}}</span>
